<template>
  <div class="box">
    <Breadcrumb class="navigation">
      <BreadcrumbItem v-for="item in breadMenuData"
        :to="item.path">
        {{ item.name }}
      </BreadcrumbItem>
    </Breadcrumb>
    <div class="introduce-box">
      <p class="sp">{{ configCharacters() + $t('key1006658') }}</p>
      <p class="tit">{{ $t('key1006667') }}</p>
      <p class="sp1 center">{{ $t('key1006668') }}</p>
      <div class="img-center">
        <img :src="imgUrl"/>
      </div>
      <div class="img-bottom-text">
        <div class="item">
          <p class="s-tit">1. {{ $t('key1006669') }}</p>
          <p class="img-description">{{ $t('key1006659') + configCharacters() + $t('key1006660') }}</p>
        </div>
        <div class="item">
          <p class="s-tit">2. {{ $t('key1006670') }}</p>
          <p class="img-description">{{ $t('key1006671') }}</p>
        </div>
        <div class="item">
          <p class="s-tit">3. {{ $t('key1001534') }}</p>
          <p class="img-description">{{$t('key1006661') + configCharacters() + $t('key1006662')}}</p>
        </div>
      </div>
      <p class="tit">{{configCharacters() + $t('key1006663')}}</p>
      <p class="sp1">{{$t('key1006664') + configCharacters() + $t('key1006665')}}</p>
      <div class="tags">
        <div class="tag">
          <p class="tag-tit">{{ $t('key1006672') }}</p>
          <p class="tag-description">{{ $t('key1006673') }}</p>
        </div>
        <div class="tag">
          <p class="tag-tit">{{ $t('key1006674') }}</p>
          <p class="tag-description">{{ $t('key1006675') }}</p>
        </div>
        <div class="tag">
          <p class="tag-tit">{{ $t('key1006676') }}</p>
          <p class="tag-description">{{ $t('key1006677') }}</p>
        </div>
        <div class="tag">
          <p class="tag-tit">{{ $t('key1003461') }}</p>
          <p class="tag-description">{{ $t('key1006678') }}</p>
        </div>
        <div class="tag">
          <p class="tag-tit">{{ $t('key1006679') }}</p>
          <p class="tag-description">{{ $t('key1006671') }}</p>
        </div>
        <div class="tag">
          <p class="tag-tit">{{ $t('key1006680') }}</p>
          <p class="tag-description">{{ $t('key1006681') }}</p>
        </div>
        <div class="tag">
          <p class="tag-tit">{{ $t('key1006682') }}</p>
          <p class="tag-description">{{ $t('key1006683') }}</p>
        </div>
        <div class="tag">
          <p class="tag-tit">{{ $t('key1006684') }}</p>
          <p class="tag-description">{{ $t('key1006673') }}</p>
        </div>
        <div class="tag">
          <p class="tag-tit">{{ $t('key1006685') }}</p>
          <p class="tag-description">{{configCharacters() + $t('key1006666')}}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';


import Mixin from "@/components/mixin/common_mixin";
import {setConfigCharacters} from "@/utils/common";

export default {
  name: 'introduce',
  mixins: [Mixin],
  data() {
    return {
      imgUrl: require('@/assets/images/introduce_01.png'),
      breadMenuData: [{
        path: '/index',
        name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006562')
      }, {
        path: '/introduce',
        name: `${setConfigCharacters()}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000065')}`
      }]
    };
  },
  created() {

  },
  props: {},
  watch: {},
  methods: {}
};
</script>

<style scoped lang="less">
.box {
  width: 1200px;
  margin: 0 auto;

  .navigation {
    padding: 10px;
  }

  .introduce-box {
    background-color: #ffffff;
    padding: 25px;
    margin-bottom: 20px;

    .tit {
      text-align: center;
      font-size: 24px;
      color: #000000;
      margin: 30px 0 10px 0;
    }

    .sp1 {
      text-align: center;
      margin-bottom: 20px;
    }

    .img-center {
      width: 620px;
      margin: 0 auto;

      img {
        width: 100%;
      }
    }

    .img-bottom-text {
      width: 808px;
      margin: 0 auto;
      display: flex;
      justify-content: space-around;

      .item {
        width: 212px;

        .s-tit {
          color: #333333;
          font-size: 14px;
          text-align: center;
          margin: 8px;
        }
      }
    }
  }

  .tags {
    display: flex;
    flex-wrap: wrap;

    .tag {
      width: 363px;
      height: 170px;
      border: 1px solid #d7d7d7;
      text-align: center;
      margin: 10px;

      .tag-tit {
        padding-top: 53px;
        font-family: 'Arial Negreta', 'Arial Normal', 'Arial', sans-serif;
        font-weight: 700;
        color: #FF5310;
        margin-bottom: 10px;
        font-size: 16px;
      }

      .tag-description {
        font-family: 'Arial Normal', 'Arial', sans-serif;
        font-weight: 400;
        color: #000000;
      }
    }
  }
}


.img-center {
  text-align: center;
}
</style>
